// Client-safe job count helpers, kept apart from liveJobCount.ts so pages can use them without
// bundling the job service into the browser.

// Token CMS editors can put in a page's meta_title to have it replaced with the live job count,
// e.g. "Discover {{jobCount}}+ Doctor Locum and Permanent Jobs".
export const JOB_COUNT_PLACEHOLDER = '{{jobCount}}';

/**
 * Rounds the total down to the nearest hundred so copy like "over 4,800" and "4,800+" stays true
 * between cache refreshes. Totals under 100 are shown exactly.
 */
export const formatJobCount = (total: number): string => {
  const rounded = total >= 100 ? Math.floor(total / 100) * 100 : total;
  return rounded.toLocaleString('en-AU');
};
